import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Componente que restaura el scroll al inicio (top: 0) en cada cambio de ruta.
 * Mejora la experiencia del usuario asegurando que cada página se vea desde el principio.
 */
export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll suave al inicio de la página en cada cambio de ruta
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  // Este componente no renderiza nada visualmente
  return null;
};
